function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBallerina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_ballerina") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8,9.859V2h6.818V12.376ZM8,12.32l4.666,1.723L8,15.764Zm6.818,3.389v3.805L11.5,30H8V18.225ZM24,9.859V2H17.181V12.376Zm0,2.461-4.668,1.723L24,15.764Zm-6.819,3.389v3.805L20.5,30H24V18.225Z",
    style: {
      fill: "#20b4ae"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallerina);
export default __webpack_public_path__ + "static/media/ballerina.301f5b458dd64ff6adbce6658d0832b5.svg";
export { ForwardRef as ReactComponent };